import { Route } from "@angular/router";
import { OrderTrackingComponent } from "./order-tracking.component";
import { OrderDetailsRouting } from "./order-details/order-details-routing";
import { Permissions } from "../../access/shared/authorization/permissions";

export const OrderTrackingRouting: Route = {
    path: 'order-tracking',
    component: OrderTrackingComponent,
    data: {
        breadcrumb: "Suivi des Demandes",
        'role': [
            Permissions.ROLE_DEMANDES,
        ],
    }, children:[
        OrderDetailsRouting
    ]
};
